import axios from "axios";
import { getToken } from "@/utils/localToken.js";
import { removeToken } from "@/utils/localToken.js";

const service = axios.create({
  baseURL: `${process.env.VUE_APP_API}`,
  // baseURL: `${CONFIG.IP_URL}/api-h5`, //如需要打包后可灵活修改ip，可打开此注释
  timeout: 15000,
});

service.interceptors.request.use(
  (config) => {
    if (getToken()) {
      config.headers["token"] = getToken();
    }
    return config;
  },
  (err) => {
    console.log(err);
  }
);

service.interceptors.response.use(
  (res) => {
    const code = res.data.code;
    if (code === 403) {
      removeToken();
    }
    return res.data;
  },
  (err) => {
    console.log(err);
  }
);

export default service;
